import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router';

import { queryClient } from '@/lib/query-client';
import { AppearanceProvider } from '@/platform/theme/appearance-provider';
import { TypographyProvider } from '@/platform/theme/typography-provider';
import { VoiceProvider } from '@/platform/voice/use-voice';
import { router } from '@/router';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <VoiceProvider>
        <AppearanceProvider>
          <TypographyProvider>
            <RouterProvider router={router} />
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
          </TypographyProvider>
        </AppearanceProvider>
      </VoiceProvider>
    </QueryClientProvider>
  );
}
